// extracted by mini-css-extract-plugin
export var divider = "_nh-0";
export var systemMessage = "_nh-1";